import { NumericFormat } from "react-number-format";
import NumericComponentProps from "./types";
import FormComponent from "../FormComponent";

const NumericComponent: React.FC<NumericComponentProps> = ({
    name,
    label,
    required,
    formData,
    allowNegative = true,
    decimalScale = 2,
    readOnly = false,
    disabled = false,
    min,
    maxLength,
    topTooltip,
    bottomTooltip,
    leftTooltip,
    rightTooltip,
    display
}) => {
    return (
        <FormComponent
            name={name}
            label={label}
            required={required}
            formData={formData}
            topTooltip={topTooltip}
            bottomTooltip={bottomTooltip}
            leftTooltip={leftTooltip}
            rightTooltip={rightTooltip}
            display={display}
        >
            <NumericFormat
                className="form-control"
                min={min}
                maxLength={maxLength}
                thousandSeparator={false}
                allowNegative={allowNegative}
                decimalScale={decimalScale}
                readOnly={readOnly}
                disabled={disabled}
                isAllowed={(values: any) => {
                    const { floatValue } = values;
                    const integerPart = Math.floor(floatValue);
                    return integerPart.toString().length <= 7;
                }}
                suffix=""
                allowLeadingZeros={false}
                onValueChange={(values) => {
                    const { floatValue } = values;
                    formData.setFieldValue(name, floatValue ?? 0)
                }}
                {...formData.getFieldProps(name)}
            />
        </FormComponent>
    );
};

export default NumericComponent;